import "./ConfirmDialog.scss";
import Modal from "../Modal/Modal";
import primaryComponents from "../../primaryComponents";

const ConfirmDialog = ({
  isOpen,
  isActive,
  setIsOpen,
  closeModal,
  title = "",
  handler = () => {},
  onConfirm,
  isLoading = false,
  isDisabled = false,
  confirmText = "Continue",
  submitBtnText,
  cancelText = "Cancel",
  cancelBtnText,
  btnClassNames = "btn btn--danger",
  cancelBtnClassNames = "btn btn--outline",
  loadingText = "Loading...",
  width = "450px",
  children,
}) => {
  const active = isOpen ?? isActive ?? false;

  const handleClose = () => {
    if (isLoading) return;
    if (typeof closeModal === "function") {
      closeModal();
    } else if (typeof setIsOpen === "function") {
      setIsOpen(false);
    }
  };

  const handleConfirm = () => {
    if (typeof onConfirm === "function") {
      onConfirm();
    } else if (typeof handler === "function") {
      handler();
    }
  };

  const finalConfirmText = submitBtnText || confirmText;
  const finalCancelText = cancelBtnText || cancelText;

  return (
    <Modal isActive={active} closeModal={handleClose} width={width}>
      <div className="confirm-dialog">
        {title && <h4 className="text-center font-weight-semibold">{title}</h4>}
        <div className="confirm-dialog__content">{children}</div>
        <div className="confirm-dialog__actions">
          <primaryComponents.Button
            onClick={handleClose}
            classNames={cancelBtnClassNames}
            isDisabled={isLoading || isDisabled}
          >
            {finalCancelText}
          </primaryComponents.Button>
          <primaryComponents.Button
            onClick={handleConfirm}
            classNames={btnClassNames}
            isLoading={isLoading}
            isDisabled={isLoading || isDisabled}
            loadingText={loadingText}
          >
            {finalConfirmText}
          </primaryComponents.Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
